import React,{useState,useEffect} from 'react'
import styles from './LeadQualityScreen.module.css'
import LeadSummaryCardComponent from './LeadSummaryCardComponent'
import { connect, useDispatch } from "react-redux";
import { fetchLeadCallingSummaryReports } from '../../Services/reports';

interface LeadCallingSummaryComponentProps{
    leadCallingScoreType: any,
    user: any,
    lqcReportDate: any
}

// const LeadCallingSummaryData = [
//     {
//         cardTitle: "Calling",
//         cardSubtitle: "Using ReadPro",
//         leadCalledPercent: "96.4",
//         leadCallingScoreType: "good",
//         totalLeads: "5324",
//         leadgetCall: "2213",
//         insufficientdata: false,
//     },
//     {
//         cardTitle: "Response Time",
//         cardSubtitle: "Calculated from receiving the lead to making the call",
//         leadCalledPercent: "85",
//         leadCallingScoreType: "good",
//         widthInHour: "1324",
//         onetosixHours: "124",
//         sixto24Hours: "56",
//         aftertwfourHours: "32",
//         insufficientdata: false,
//     },
//     {
//         cardTitle: "Follow-up Calls",
//         cardSubtitle: "Calls Made to Unresponsive Leads within 24 hours",
//         leadCalledPercent: "94.5",
//         leadCallingScoreType: "good",
//         leadwithonetotwoattempt: "30",
//         leadwiththreeplusattempt: "80",
//         insufficientdata: false,
//     },
//     {
//         cardTitle: "Status Updates",
//         cardSubtitle: "Post Calling Status updates on ReadPro",
//         leadCalledPercent: "73.5",
//         leadCallingScoreType: "good",
//         statusnotUpdated: "4324",
//         statusupdated: "3646",
//         insufficientdata: false,
//     },
// ]

const LeadCallingSummaryComponent: React.FC<LeadCallingSummaryComponentProps> = ({leadCallingScoreType, user, lqcReportDate}) => {
    const [reportsData, setReportsData] = useState<any>([]);

    leadCallingScoreType = leadCallingScoreType ? leadCallingScoreType.toLowerCase() : "";

    useEffect(() => {
        const setLeadCallingSummaryReports = async () => {
            await fetchLeadCallingSummaryReports(Number(user.user_super_oid), lqcReportDate, "Lead Calling Summary", setReportsData);
        };

        if (user.user_super_oid && lqcReportDate) {
            setLeadCallingSummaryReports();
        }
    }, [
        user.user_super_oid, lqcReportDate
    ]);
  return (
    <div className={styles.LqscsWrapper}>
        <div className={styles.LqscsTitle}>Lead Calling Summary 
            <span style={{marginLeft:"0.5rem"}} className={`${styles.LqscsTitleTag} ${styles[leadCallingScoreType]}`}>{leadCallingScoreType && leadCallingScoreType.charAt(0).toUpperCase() + leadCallingScoreType.slice(1)}</span>
            </div>
        <div className={styles.LqscsCards}>
            {
                reportsData?.map((item: any, index: any) => {
                    return <LeadSummaryCardComponent data={item} key={index} />
                })
            }
        </div>
    </div>
  )
}

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        lqcReportDate: state.lqcReportData.lqcReportDate
    };
};

export default connect(mapStateToProps)(LeadCallingSummaryComponent);